<mvs-crud-page [objectStructureRequest]="objectBrowserRequest"></mvs-crud-page>